import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg } from 'utils';

export const MASTER_CONFIG_FETCH_INIT = createAction('MASTER_CONFIG_FETCH_INIT');
export const MASTER_CONFIG_FETCH_SUCCESS = createAction('MASTER_CONFIG_FETCH_SUCCESS');
export const MASTER_CONFIG_FETCH_FAIL = createAction('MASTER_CONFIG_FETCH_FAIL');

export const MASTER_CONFIG_CREATE_INIT = createAction('MASTER_CONFIG_CREATE_INIT');
export const MASTER_CONFIG_CREATE_SUCCESS = createAction('MASTER_CONFIG_CREATE_SUCCESS');
export const MASTER_CONFIG_CREATE_FAIL = createAction('MASTER_CONFIG_CREATE_FAIL');

export const MASTER_CONFIG_UPDATE_INIT = createAction('MASTER_CONFIG_UPDATE_INIT');
export const MASTER_CONFIG_UPDATE_SUCCESS = createAction('MASTER_CONFIG_UPDATE_SUCCESS');
export const MASTER_CONFIG_UPDATE_FAIL = createAction('MASTER_CONFIG_UPDATE_FAIL');

export const MASTER_CONFIG_CLEAR = createAction('MASTER_CONFIG_CLEAR');

export const fetchMasterConfigs = ({ siteId }) => {
  return async (dispatch) => {
    dispatch(MASTER_CONFIG_FETCH_INIT());

    try {
      const res = await axios.get(`${url}/masterConfig/`, {
        params: { siteId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      return dispatch(
        MASTER_CONFIG_FETCH_SUCCESS({ list: res.data.data })
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(MASTER_CONFIG_FETCH_FAIL({ error }));
    }
  };
};

export const createMasterConfig = ({ siteId, configName, fields }) => {
  return async (dispatch) => {
    dispatch(MASTER_CONFIG_CREATE_INIT());

    try {
      const res = await axios.post(
        `${url}/masterConfig/create`,
        { siteId, configName, fields },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      toastr.success('', 'Field created successfully');
      return dispatch(
        MASTER_CONFIG_CREATE_SUCCESS({ config: res.data.data })
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(MASTER_CONFIG_CREATE_FAIL({ error }));
    }
  };
};

export const updateMasterConfig = ({ id, configName, fields }) => {
  return async (dispatch) => {
    dispatch(MASTER_CONFIG_UPDATE_INIT());

    try {
      const res = await axios.put(
        `${url}/masterConfig/${id}`,
        { configName, fields },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      toastr.success('', 'Master config updated successfully');
      return dispatch(
        MASTER_CONFIG_UPDATE_SUCCESS({ config: res.data.data })
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(MASTER_CONFIG_UPDATE_FAIL({ error }));
    }
  };
};
